import React, {Fragment} from 'react';
import Header from './pageMain/Header';
import Resumen from './pageMain/Resumen';
import Resultado from './pageMain/Resultado';
import Tecnologias from './pageMain/Tecnologias';
import Next from './pageMain/Next';
import Info from './pageMain/Info';
import Footer from './pageMain/Footer';



const MainPage = () => {
    return (  
        <Fragment>
            <Header />
            <Resumen />
            <Resultado />
            <Tecnologias />
            <Next />
            <Info />
            <Footer />
        </Fragment>
    );
}
 
export default MainPage;